module.exports = __webpack_public_path__ + "static/media/Teams-arrow-left.4f6c8d27.svg";